import { render, staticRenderFns } from "./newUserSum.vue?vue&type=template&id=48d3deb0&scoped=true&"
import script from "./newUserSum.vue?vue&type=script&lang=js&"
export * from "./newUserSum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d3deb0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48d3deb0')) {
      api.createRecord('48d3deb0', component.options)
    } else {
      api.reload('48d3deb0', component.options)
    }
    module.hot.accept("./newUserSum.vue?vue&type=template&id=48d3deb0&scoped=true&", function () {
      api.rerender('48d3deb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/dataManage/newUserSum/newUserSum.vue"
export default component.exports